import {Page} from "../../../flair/Page.es6";

Page.match("/app/va/settings/").go(function() {
	let brandsContainer = document.getElementById("settings-brands");
	brandsContainer.querySelector("[name='brand-name']").addEventListener("change", e => {
		let slugEl = brandsContainer.querySelector("[name='brand-slug']");
		let name = e.target.value;
		slugEl.value = name.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-');
	});
	brandsContainer.querySelectorAll("button.managersButton").forEach(button => {
		button.addEventListener("click", clickManagersButton);
	})
});

function clickManagersButton() {
	let dialog = this.parentElement.querySelector("dialog");
	dialog.showModal();
}
